import React from "react";

interface NavigationButtonsProps {
  currentStep: number;
  totalSteps: number;
  onPrevious?: () => void;
  onNext?: (() => void) | undefined;
  onSubmit?: (() => void) | undefined;
  previousText?: string;
  nextText?: string;
  submitText?: string;
  showStepIndicator?: boolean;
  nextDisabled?: boolean;
  submitDisabled?: boolean;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  onSubmit,
  previousText = "Previous",
  nextText = "Next",
  submitText = "Submit",
  showStepIndicator = true,
  nextDisabled: externalNextDisabled = false,
  submitDisabled: externalSubmitDisabled = false,
}) => {
  const prevDisabled = currentStep === 1 || !onPrevious;
  const nextDisabled = currentStep < totalSteps ? !onNext || externalNextDisabled : false;
  const submitDisabled = currentStep >= totalSteps ? !onSubmit || externalSubmitDisabled : false;

  return (
    <div className="flex justify-between mt-8">
      <button
        onClick={onPrevious ?? (() => {})}
        disabled={prevDisabled}
        className={`px-6 py-2 rounded-lg font-semibold transition-all ${
          prevDisabled
            ? "bg-primary-200 text-gray-400 cursor-not-allowed"
            : "bg-primary-600 text-white hover:bg-primary-700"
        }`}
      >
        {previousText}
      </button>

      {showStepIndicator && (
        <div className="flex items-center space-x-2">
          <span className="text-sm text-gray-500">
            Step {currentStep} of {totalSteps}
          </span>
        </div>
      )}

      {currentStep < totalSteps ? (
        <button
          onClick={onNext ?? (() => {})}
          disabled={nextDisabled}
          className={`px-6 py-2 rounded-lg font-semibold transition-all ${
            nextDisabled
              ? "bg-primary-200 text-gray-400 cursor-not-allowed"
              : "bg-primary-600 text-white hover:bg-primary-700"
          }`}
        >
          {nextText}
        </button>
      ) : (
        <button
          onClick={onSubmit ?? (() => {})}
          disabled={submitDisabled}
          className={`px-6 py-2 rounded-lg font-semibold transition-all ${
            submitDisabled
              ? "bg-primary-200 text-gray-400 cursor-not-allowed"
              : "bg-primary-700 text-white hover:bg-primary-800"
          }`}
        >
          {submitText}
        </button>
      )}
    </div>
  );
};
